import Vue from 'vue'

Vue.filter('channelType', type => {
  if (type === 'amio_chat') return 'Amio Chat'
  if (type === 'email') return 'Email'
  if (type === 'facebook_messenger') return 'Facebook Messenger'
  if (type === 'mobile') return 'Mobile'
  if (type === 'rbm') return 'RCS Business Messages'
  if (type === 'telegram') return 'Telegram'
  if (type === 'viber') return 'Viber'
  if (type === 'viber_business_messages') return 'Viber Business Messages'
  if (type === 'whatsapp') return 'WhatsApp'

  return type
})
